<template>
  <vl-properties>
    <vl-properties-column mod-full>
      <vl-properties-list>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.id') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.id }}</vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.triggerType') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.triggerType?.name }}</vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.description') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.description }}</vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.deliveryProcessDefinition') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">
          <PbsEntityRouterLink
            v-if="detail.deliveryProcessDefinition"
            type="deliveryProcessDefinition"
            :detail="detail.deliveryProcessDefinition"
          />
          <span v-else>-</span>
        </vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.productProcessDefinition') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">
          <PbsEntityRouterLink
            v-if="detail.productProcessDefinition"
            type="productProcessDefinition"
            :detail="detail.productProcessDefinition"
          />
          <span v-else>-</span>
        </vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.job') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.job ? detail.job : `-` }}</vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.schedule') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">
          <span>{{ detail.schedule ? detail.schedule : `-` }}</span>
          <div v-if="detail.cronDescription" class="vl-u-spacer-top--small">
            {{ detail.cronDescription }}
          </div>
        </vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.triggerDeliveryProcessDefinition') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">
          <PbsEntityRouterLink
            v-if="detail.triggerDeliveryProcessDefinition"
            type="deliveryProcessDefinition"
            :detail="detail.triggerDeliveryProcessDefinition"
          />
          <span v-else>-</span>
        </vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.triggerProductProcessDefinition') }}</vl-properties-label>
                <vl-properties-data class="vl-properties-data-custom">
          <PbsEntityRouterLink
            v-if="detail.triggerProductProcessDefinition"
            type="productProcessDefinition"
            :detail="detail.triggerProductProcessDefinition"
          />
          <span v-else>-</span>
        </vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.triggerSource') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.triggerSource?.name ? detail.triggerSource.name : `-` }}</vl-properties-data>
        <vl-properties-label class="vl-properties-label-custom">{{ $t('processtrigger.detail.isEnabled') }}</vl-properties-label>
        <vl-properties-data class="vl-properties-data-custom">{{ detail.isEnabled ? $t('general.yes') : $t('general.no') }}</vl-properties-data>
      </vl-properties-list>
    </vl-properties-column>
  </vl-properties>
</template>

<script lang="ts" setup>
import { ProcessTriggerDetailDto } from '@/api/backoffice/clients';
import { useProcessTriggerDetailStore } from '../../store/process-trigger/process-trigger-detail.store';
import { computed } from 'vue';
import PbsEntityRouterLink from '@/components/PbsEntityRouterLink.vue';

const store = useProcessTriggerDetailStore();

const detail = computed((): ProcessTriggerDetailDto => {
  return store.detail;
});
</script>

<style lang="scss" scoped>
.vl-properties-label-custom {
  flex: 0 0 30%;
  max-width: 40rem;
}

.vl-properties-data-custom {
  flex: 0 0 70%;
  min-width: calc(100% - 40rem);
}
</style>
